import { faLayerPlus } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { withTheme } from '@emotion/react';
import PropTypes from 'prop-types';
import React, { Fragment, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { changeCreateProjectInput } from '../../actions/create-project-form';
import { createProjectStart } from '../../actions/project';
import { algarDeskFolderTypes } from '../../constants/project';
import { allProjectsSelector, createProjectSelector, isAllowedToUseAlgarDeskSelector, isBtoBSelector, isOnlyDeskSelector, userSelector } from '../../selectors';
import { createProjectFormSelector } from '../../selectors/form';
import { LoadingSpinnerSmall } from '../loading-spinner';
import SelectInput from '../select-input';
import SelectInputProjectTypes from '../select-input-project-types';
import useDefaultProjectType from './hooks/use-default-project-type';
import useAddressAutocomplete from './hooks/use-address-autocomplete';
import { CreateButton, CreateProjectConatainer, ErrorMessage, InputContainer, InputContainerDesk, InputLabel, InputText, LoadingContainer, PlacesAutocompleteInput, PlacesAutocompleteInputWrapper, StyledAutocompleteLabel, StyledLi, StyledUl, SuggestionListItem, SuggestionsList, Title, ValidateButtonContainer, WarningUniqueProject } from './styled';
const PageCreateProject = _ref => {
  let {
    showTitle,
    showValidateBtn,
    theme
  } = _ref;
  const tunnelBaseUrl = window.processRuntime.env?.PAYMENT_TUNNEL_BASE_URL;
  const {
    createProjectLoading,
    createProjectError
  } = useSelector(createProjectSelector);
  const dispatch = useDispatch();
  const formValues = useSelector(createProjectFormSelector);
  const {
    address,
    projectTypesCodes,
    projectname,
    typeClient
  } = formValues;
  const [folderType, setFolderType] = useState(algarDeskFolderTypes[1]);
  const defaultProjectType = useDefaultProjectType(folderType);
  const [projectTypes, setProjectTypes] = useState(defaultProjectType);
  const [hasUniqueProjectType, setHasUniqueProjectType] = useState(false);
  const isBtoB = useSelector(isBtoBSelector);
  const isOnlyDesk = useSelector(isOnlyDeskSelector);
  const isAllowedToUseDesk = useSelector(isAllowedToUseAlgarDeskSelector);
  const isClientDesk = isAllowedToUseDesk && folderType.value === algarDeskFolderTypes[0].value;

  // Hook pour l'autocomplete BAN
  const {
    suggestions: banSuggestions,
    suggestionsOpened,
    loading: banLoading,
    searchAddress,
    closeSuggestions
  } = useAddressAutocomplete(500);
  const newProjectData = {
    address,
    projectTypesCodes,
    projectname,
    typeClient
  };
  const onAddressChange = event => {
    const value = event.target ? event.target.value : event;
    dispatch(changeCreateProjectInput({
      name: 'address',
      value
    }));
    searchAddress(value);
  };
  const uniqueProjectTypes = ['shop-sign', 'commercial-parcel', 'PMR-access', 'store-terrace', 'erp5', 'presign-advertising'];
  const onChangeProjectTypes = selectedOptions => {
    const projectValues = selectedOptions.map(el => el.value);
    const isAnyProjectTypeIncluded = projectValues.some(value => uniqueProjectTypes.includes(value));
    if (isAnyProjectTypeIncluded) {
      setHasUniqueProjectType(true);
      // Trouver le projet unique actuellement sélectionné (pas forcément le dernier ajouté)
      const uniqueProjectInSelection = selectedOptions.find(option => uniqueProjectTypes.includes(option.value));
      setProjectTypes(uniqueProjectInSelection);
    } else {
      if (setHasUniqueProjectType) setHasUniqueProjectType(false);
      setProjectTypes(selectedOptions);
    }

    // selectedOptions can contain multiple worktype now, should be an array
    dispatch(changeCreateProjectInput({
      name: 'projectTypesCodes',
      value: selectedOptions.map(el => el.value)
    }));
  };
  const onChangeProjectName = event => {
    dispatch(changeCreateProjectInput({
      name: 'projectname',
      value: event.target.value
    }));
  };
  const onChangeFolderType = e => {
    // prevent next logic to be run, need to be done better
    if (e.length === 0) return;
    // this logic is for the multi=true used to keep the same UX and UI on inputs, but we do not want multi here
    if (folderType === algarDeskFolderTypes[1]) setFolderType(algarDeskFolderTypes[0]);else setFolderType(algarDeskFolderTypes[1]);
    onChangeProjectTypes([]);
  };
  const handleClickValidate = React.useCallback(event => {
    event.preventDefault();
    if ((isBtoB || isAllowedToUseDesk) && address && projectTypes) {
      dispatch(createProjectStart(newProjectData));
    } else {
      window.location.href = `${tunnelBaseUrl}/adresse?action=create-new-project`;
    }
  }, [isBtoB, isAllowedToUseDesk, address, projectTypes, newProjectData]);
  const onSuggestionSelect = selectedAddress => {
    dispatch(changeCreateProjectInput({
      name: 'address',
      value: selectedAddress
    }));
    closeSuggestions();
  };
  const createButtonDisabled = createProjectLoading || isBtoB && (!address || !projectTypes || projectTypes.length === 0);

  // Update typeClient
  React.useEffect(() => {
    const _typeClient = isClientDesk ? 'Desk' : 'BtoB';
    dispatch(changeCreateProjectInput({
      name: 'typeClient',
      value: _typeClient
    }));
  }, [isClientDesk]);
  return /*#__PURE__*/React.createElement(CreateProjectConatainer, {
    allowDesk: isAllowedToUseDesk
  }, showTitle && /*#__PURE__*/React.createElement(Title, null, /*#__PURE__*/React.createElement("span", null, "Cr\xE9er un nouveau dossier")), createProjectError && /*#__PURE__*/React.createElement(ErrorMessage, null, createProjectError.message), isBtoB || isAllowedToUseDesk ? /*#__PURE__*/React.createElement(Fragment, null, isAllowedToUseDesk && /*#__PURE__*/React.createElement(InputContainerDesk, null, /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: "folder-type"
  }, "Type de dossier"), /*#__PURE__*/React.createElement(SelectInput, {
    options: isOnlyDesk ? [algarDeskFolderTypes[0]] : algarDeskFolderTypes,
    closeMenuOnSelect: true,
    placeholder: "Choisissez un type de dossier",
    hideSelectedOptions: true,
    value: folderType,
    isMulti: true,
    onChange: event => onChangeFolderType(event)
  })), /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(StyledAutocompleteLabel, {
    htmlFor: "address"
  }, "Adresse postale de votre projet"), /*#__PURE__*/React.createElement(PlacesAutocompleteInputWrapper, null, /*#__PURE__*/React.createElement(PlacesAutocompleteInput, {
    type: "text",
    value: address !== undefined ? address : '',
    onChange: onAddressChange,
    placeholder: "1 rue de Paris, 75000 Paris",
    id: "address",
    autoComplete: "off"
  }), banLoading && /*#__PURE__*/React.createElement(LoadingContainer, null, /*#__PURE__*/React.createElement(LoadingSpinnerSmall, {
    size: 15,
    borderWidth: 2
  })), suggestionsOpened && banSuggestions.length > 0 && /*#__PURE__*/React.createElement(SuggestionsList, null, banSuggestions.map((suggestion, index) => /*#__PURE__*/React.createElement(SuggestionListItem, {
    key: index,
    onClick: () => onSuggestionSelect(suggestion.address)
  }, /*#__PURE__*/React.createElement("span", null, suggestion.address)))))), /*#__PURE__*/React.createElement(InputContainer, null, /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: "project-name"
  }, "Nom du dossier"), /*#__PURE__*/React.createElement(InputText, {
    type: "text",
    value: projectname,
    onChange: onChangeProjectName,
    placeholder: "Extension M. Bonnet",
    onClick: e => e.stopPropagation(),
    id: "project-name"
  })), /*#__PURE__*/React.createElement(InputContainer, null, /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: "project-types"
  }, "Types de projets"), /*#__PURE__*/React.createElement(SelectInputProjectTypes, {
    value: projectTypes,
    onChange: onChangeProjectTypes,
    name: "project-types",
    isBtoB: isBtoB,
    isDesk: isClientDesk,
    hideSelectedOptions: true,
    closeMenuOnSelect: true
  })), hasUniqueProjectType && /*#__PURE__*/React.createElement(WarningUniqueProject, null, "Attention, le projet ", projectTypes?.label, " doit \xEAtre d\xE9pos\xE9 de mani\xE8re ind\xE9pendante \xE0 tout autre projet.", /*#__PURE__*/React.createElement("br", null), "Si vous souhaitez cr\xE9er un dossier avec plusieurs projets incluant une demande d\u2019", projectTypes?.label, ", cr\xE9ez alors un dossier avec le projet ", projectTypes?.label, " et un autre dossier avec les projets restants.")) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(StyledUl, null, /*#__PURE__*/React.createElement(StyledLi, null, "D\xE9crivez votre dossier"), /*#__PURE__*/React.createElement(StyledLi, null, "Un de nos conseillers vous contact pour vous soumettre un devis."), /*#__PURE__*/React.createElement(StyledLi, null, "D\xE9marrez votre nouveau dossier !"))), showValidateBtn && /*#__PURE__*/React.createElement(ValidateButtonContainer, {
    isbtob: isBtoB
  }, /*#__PURE__*/React.createElement(CreateButton, {
    disabled: createButtonDisabled,
    onClick: createButtonDisabled ? undefined : handleClickValidate
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    color: theme.colors.primary,
    icon: faLayerPlus
  }), /*#__PURE__*/React.createElement("span", null, "Cr\xE9er le dossier"), createProjectLoading && /*#__PURE__*/React.createElement(LoadingSpinnerSmall, {
    size: 15,
    borderWidth: 2
  }))));
};
PageCreateProject.defaultProps = {
  showTitle: true,
  showValidateBtn: true
};
PageCreateProject.propTypes = {
  showTitle: PropTypes.bool,
  showValidateBtn: PropTypes.bool
};
export default withTheme(PageCreateProject);